import { Component, OnInit } from '@angular/core';
import { Select, Select$ } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { toArray } from '../../../../utils';

@Component({
  selector: 'mwo-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.scss']
})
export class InformationDialogComponent implements OnInit {
  protected readonly environment = environment;

  @Select(['remote', 'name']) playerName$: Observable<string>;
  @Select(['player', 'businessStatus', 'bidStatus', 'message']) playerCode$: Observable<string>;
  @Select(['player', 'businessStatus', 'syncStatus', 'lastSuccessfulSync']) lastUpdate$: Observable<string>;
  @Select(['player', 'businessStatus', 'syncStatus']) status$: Observable<any>;
  @Select$(['playlists'], toArray) playlists$: Observable<any[]>;

  syncErrorMessage: string;
  playlistNumber: number;
  mediaNumber: number;

  constructor() { }

  ngOnInit(): void {
    this.status$.subscribe((status) => {
      if (status.type === 'ERROR') {
        this.syncErrorMessage = status.message;
      }
    });
    this.playlists$.subscribe((playlists) => {
      this.playlistNumber = Object.keys(playlists[0]).length - 1;
      this.mediaNumber = Object.keys(playlists[0]).reduce((acc, playlist) => acc + playlists[0][playlist].tracks, 0);
    });
  }

}
